export default __webpack_public_path__ + "static/media/female-doctor.7107efea.jpeg";